/* Finance: budgets, supplier invoices (AP) and reports.
 * Shared vocabulary (Save, Cancel, statuses, …) lives in common.js / shell.js. */
const finance = {
  // --- Budgets: list page ----------------------------------------------------
  'Period budgets by property and cost centre. Spend on coded requisitions and purchase orders is checked against these — warn-only.':
    'Anggaran per periode berdasarkan properti dan pusat biaya. Pengeluaran pada permintaan barang dan pesanan pembelian yang diberi kode diperiksa terhadap anggaran ini — hanya berupa peringatan.',
  'New budget': 'Anggaran baru',
  'Could not load budgets': 'Tidak dapat memuat anggaran',
  'Budget updated': 'Anggaran diperbarui',
  'Budget created': 'Anggaran dibuat',
  'Could not save budget': 'Tidak dapat menyimpan anggaran',
  'Budget deleted': 'Anggaran dihapus',
  'Could not delete budget': 'Tidak dapat menghapus anggaran',
  'Organization': 'Organisasi',
  'All cost centres': 'Semua pusat biaya',
  'Cost centre': 'Pusat biaya',
  'Whole cost centre': 'Seluruh pusat biaya',
  'Allocated': 'Dialokasikan',
  'Committed': 'Terkomitmen',
  'Actual': 'Aktual',
  'Remaining': 'Sisa',
  '% used': '% terpakai',
  'Edit budget': 'Ubah anggaran',
  'Delete budget': 'Hapus anggaran',
  'Filter by property': 'Filter berdasarkan properti',
  'Filter by cost centre': 'Filter berdasarkan pusat biaya',
  'No budgets yet': 'Belum ada anggaran',
  'Define a budget for a cost centre and period to start tracking spend against it.':
    'Tetapkan anggaran untuk satu pusat biaya dan periode untuk mulai melacak pengeluaran terhadapnya.',
  'Set the cost centre, period and allocated amount. Optionally scope to a single GL account.':
    'Atur pusat biaya, periode, dan jumlah alokasi. Secara opsional, batasi ke satu akun GL.',
  'Delete the {costCenter} budget for {period}? This cannot be undone.':
    'Hapus anggaran {costCenter} untuk {period}? Tindakan ini tidak dapat dibatalkan.',

  // --- Budgets: form ----------------------------------------------------------
  '— Select —': '— Pilih —',
  '— Whole cost centre —': '— Seluruh pusat biaya —',
  'All properties (organization)': 'Semua properti (organisasi)',
  'GL account': 'Akun GL',
  'Period type': 'Tipe periode',
  'Monthly': 'Bulanan',
  'Quarterly': 'Triwulanan',
  'Annual': 'Tahunan',
  'Custom': 'Kustom',
  'Month': 'Bulan',
  'Quarter': 'Triwulan',
  'Year': 'Tahun',
  'Start': 'Mulai',
  'End': 'Berakhir',
  'Label': 'Label',
  'e.g. Summer season': 'mis. Musim panas',
  'Optional context': 'Konteks opsional',
  'Save budget': 'Simpan anggaran',
  'Create budget': 'Buat anggaran',

  // --- Budgets: availability panel --------------------------------------------
  'Budget': 'Anggaran',
  'No budget defined for cost centre': 'Tidak ada anggaran yang ditetapkan untuk pusat biaya',
  'in the current period.': 'pada periode berjalan.',
  'Actual (received)': 'Aktual (diterima)',
  'Pending requisitions': 'Permintaan barang menunggu',
  'After this document': 'Setelah dokumen ini',
  'This document would exceed the budget by {amount}. Submission is still allowed.':
    'Dokumen ini akan melampaui anggaran sebesar {amount}. Pengajuan tetap diizinkan.',

  // --- Invoices: statuses & match ---------------------------------------------
  'Disputed': 'Disengketakan',
  'Not matched': 'Belum dicocokkan',
  'Matched': 'Cocok',
  'Price variance': 'Selisih harga',
  'Qty variance': 'Selisih kuantitas',
  'Price + qty variance': 'Selisih harga + kuantitas',
  'Match': 'Kecocokan',
  'Variance': 'Selisih',
  'Has variance': 'Ada selisih',
  'Clean match': 'Cocok sempurna',

  // --- Invoices: list page & AP summary ----------------------------------------
  'Capture supplier invoices against purchase orders. The system runs a three-way match (PO ↔ receipts ↔ invoice) and flags price and quantity variances before you approve and pay.':
    'Catat faktur pemasok terhadap pesanan pembelian. Sistem menjalankan pencocokan tiga arah (PO ↔ penerimaan ↔ faktur) dan menandai selisih harga serta kuantitas sebelum Anda menyetujui dan membayar.',
  'New invoice': 'Faktur baru',
  'Failed to load invoices.': 'Gagal memuat faktur.',
  'Invoice date': 'Tanggal faktur',
  'Ref {number}': 'Ref {number}',
  'Outstanding AP': 'Utang usaha berjalan',
  '{count} approved, awaiting payment': '{count} disetujui, menunggu pembayaran',
  '{count} past due': '{count} lewat jatuh tempo',
  'Nothing past due': 'Tidak ada yang lewat jatuh tempo',
  'GRNI accrual': 'Akrual GRNI',
  'Received, not invoiced': 'Diterima, belum difakturkan',
  'POs': 'PO',
  'On hold': 'Ditahan',
  '{count} disputed': '{count} disengketakan',
  '{count} in approval': '{count} dalam persetujuan',
  '{count} draft': '{count} draf',
  'Payables aging': 'Umur utang usaha',
  'Approved invoices awaiting payment, aged by due date.':
    'Faktur yang disetujui dan menunggu pembayaran, dikelompokkan menurut tanggal jatuh tempo.',
  'Current': 'Belum jatuh tempo',
  '1–30 days': '1–30 hari',
  '31–60 days': '31–60 hari',
  '61–90 days': '61–90 hari',
  '90+ days': '90+ hari',
  'Search by invoice, supplier or PO number…': 'Cari berdasarkan nomor faktur, pemasok, atau PO…',
  "Couldn't load invoices": 'Tidak dapat memuat faktur',
  'No matching invoices': 'Tidak ada faktur yang cocok',
  'No invoices yet': 'Belum ada faktur',
  'Try adjusting your search or filters.': 'Coba sesuaikan pencarian atau filter Anda.',
  'Raise an invoice against an issued purchase order to start the three-way match.':
    'Buat faktur terhadap pesanan pembelian yang telah diterbitkan untuk memulai pencocokan tiga arah.',

  // --- Invoices: detail page -----------------------------------------------------
  'Invoice not found.': 'Faktur tidak ditemukan.',
  "Couldn't load invoice": 'Tidak dapat memuat faktur',
  'Not found.': 'Tidak ditemukan.',
  'Back to invoices': 'Kembali ke faktur',
  'Invoice {number}': 'Faktur {number}',
  'Invoice updated and re-matched': 'Faktur diperbarui dan dicocokkan ulang',
  'Could not save invoice': 'Tidak dapat menyimpan faktur',
  'Approve step {order}': 'Setujui langkah {order}',
  'Dispute': 'Sengketakan',
  'Mark paid': 'Tandai dibayar',
  'Purchase order': 'Pesanan pembelian',
  'Supplier invoice #': 'No. faktur pemasok',
  'Due date': 'Tanggal jatuh tempo',
  'Approved by': 'Disetujui oleh',
  'Approval note': 'Catatan persetujuan',
  'Paid by': 'Dibayar oleh',
  'Payment ref': 'Ref pembayaran',
  'In approval — step {order} of {total}': 'Dalam persetujuan — langkah {order} dari {total}',
  ', awaiting {role}': ', menunggu {role}',
  'This invoice has a variance, so the full approval chain is required.':
    'Faktur ini memiliki selisih, sehingga rantai persetujuan lengkap diperlukan.',
  'You can approve this step.': 'Anda dapat menyetujui langkah ini.',
  'by {name}': 'oleh {name}',
  'on {date}': 'pada {date}',
  'Reason: {reason}': 'Alasan: {reason}',
  'Edit the billed values and re-approve, or cancel.':
    'Ubah nilai tagihan dan setujui ulang, atau batalkan.',
  'Invoice total': 'Total faktur',
  'Variance flagged': 'Selisih ditandai',
  'Clean': 'Bersih',
  'Variance lines': 'Baris selisih',
  'Edit billed lines': 'Ubah baris tagihan',
  'Adjust quantities and prices to what the supplier billed, then save to re-run the match.':
    'Sesuaikan kuantitas dan harga dengan yang ditagihkan pemasok, lalu simpan untuk menjalankan ulang pencocokan.',
  'Their reference': 'Referensi mereka',
  'Tax ({currency})': 'Pajak ({currency})',
  'Freight ({currency})': 'Ongkos kirim ({currency})',
  'Other ({currency})': 'Lainnya ({currency})',
  'Other charges ({currency})': 'Biaya lainnya ({currency})',
  'Freight': 'Ongkos kirim',
  'Other': 'Lainnya',
  'Ordered / received / billed': 'Dipesan / diterima / ditagih',
  '{delta} vs received': '{delta} vs diterima',
  '{delta} vs PO': '{delta} vs PO',
  'PO price': 'Harga PO',
  'Billed price': 'Harga tagihan',
  'Billed qty': 'Kts ditagih',
  'Line total': 'Total baris',
  'Ordered': 'Dipesan',
  'Three-way match': 'Pencocokan tiga arah',
  'Each line compares the quantity billed against what was received, and the billed price against the purchase order.':
    'Setiap baris membandingkan kuantitas yang ditagih dengan yang diterima, dan harga tagihan dengan pesanan pembelian.',
  'Approval chain': 'Rantai persetujuan',
  'Follows the supplier-invoice approval workflow — amount-tiered approver roles. A variance requires the full chain.':
    'Mengikuti alur kerja persetujuan faktur pemasok — peran penyetuju berjenjang berdasarkan jumlah. Selisih memerlukan rantai lengkap.',
  'Audit trail for this invoice — who did what and when.':
    'Jejak audit untuk faktur ini — siapa melakukan apa dan kapan.',
  'No activity yet': 'Belum ada aktivitas',
  'Capture, approval, dispute, payment and cancellation events will appear here.':
    'Peristiwa pencatatan, persetujuan, sengketa, pembayaran, dan pembatalan akan muncul di sini.',
  'Someone': 'Seseorang',
  'Approve invoice': 'Setujui faktur',
  'Approve your step of the chain. The invoice advances to the next approver, or is fully approved (and posts its variance to budget) once the final step clears.':
    'Setujui langkah Anda dalam rantai. Faktur berlanjut ke penyetuju berikutnya, atau disetujui sepenuhnya (dan selisihnya dibukukan ke anggaran) setelah langkah terakhir selesai.',
  'This routes the invoice through the purchase-order approval chain (a variance requires the full chain). When the final step clears, the invoice is approved and its price/quantity variance is posted to budget actuals.':
    'Ini meneruskan faktur melalui rantai persetujuan pesanan pembelian (selisih memerlukan rantai lengkap). Setelah langkah terakhir selesai, faktur disetujui dan selisih harga/kuantitasnya dibukukan ke aktual anggaran.',
  'Approve step': 'Setujui langkah',
  'Invoice approved': 'Faktur disetujui',
  'Could not approve invoice': 'Tidak dapat menyetujui faktur',
  'Comment (optional)': 'Komentar (opsional)',
  'Dispute invoice': 'Sengketakan faktur',
  "Hold the invoice back over a variance. An approved invoice's budget posting is withdrawn. You can edit and re-approve later.":
    'Tahan faktur karena ada selisih. Pembukuan anggaran faktur yang sudah disetujui akan ditarik. Anda dapat mengubah dan menyetujui ulang nanti.',
  'Mark disputed': 'Tandai disengketakan',
  'Invoice disputed': 'Faktur disengketakan',
  'Could not dispute invoice': 'Tidak dapat menyengketakan faktur',
  "What's the issue? (optional)": 'Apa masalahnya? (opsional)',
  'Mark invoice paid': 'Tandai faktur dibayar',
  'Record that this approved invoice has been settled.':
    'Catat bahwa faktur yang disetujui ini telah dilunasi.',
  'Invoice marked paid': 'Faktur ditandai dibayar',
  'Could not mark invoice paid': 'Tidak dapat menandai faktur dibayar',
  'Payment reference (optional)': 'Referensi pembayaran (opsional)',
  'Cancel invoice': 'Batalkan faktur',
  'Void this invoice. If it was approved, its budget posting is withdrawn.':
    'Batalkan faktur ini. Jika sudah disetujui, pembukuan anggarannya akan ditarik.',
  'Invoice cancelled': 'Faktur dibatalkan',
  'Could not cancel invoice': 'Tidak dapat membatalkan faktur',
  'Reason (optional)': 'Alasan (opsional)',

  // --- Invoices: capture form ----------------------------------------------------
  'Choose a purchase order first': 'Pilih pesanan pembelian terlebih dahulu',
  'Enter a billed quantity for at least one line': 'Masukkan kuantitas tagihan untuk setidaknya satu baris',
  'Invoice {number} captured': 'Faktur {number} tercatat',
  'Could not create invoice': 'Tidak dapat membuat faktur',
  'No supplier': 'Tanpa pemasok',
  'Not allowed': 'Tidak diizinkan',
  "You don't have permission to capture invoices.": 'Anda tidak memiliki izin untuk mencatat faktur.',
  "Pick the purchase order being billed, then enter the quantities and prices the supplier charged. We'll match them against what was ordered and received.":
    'Pilih pesanan pembelian yang ditagih, lalu masukkan kuantitas dan harga yang dikenakan pemasok. Kami akan mencocokkannya dengan apa yang dipesan dan diterima.',
  'No issued purchase orders are available to invoice. A PO must be sent to the supplier (and ideally received) before it can be invoiced.':
    'Tidak ada pesanan pembelian terbit yang tersedia untuk difakturkan. PO harus dikirim ke pemasok (dan idealnya sudah diterima) sebelum dapat difakturkan.',
  'Select a purchase order…': 'Pilih pesanan pembelian…',
  'Search by PO or supplier…': 'Cari berdasarkan PO atau pemasok…',
  'Choose a purchase order': 'Pilih pesanan pembelian',
  'Pick the PO this invoice bills against to load its received lines.':
    'Pilih PO yang ditagih faktur ini untuk memuat baris yang telah diterima.',
  'Nothing received yet': 'Belum ada yang diterima',
  'This purchase order has no received lines to invoice. Receive the goods first.':
    'Pesanan pembelian ini tidak memiliki baris yang diterima untuk difakturkan. Terima barang terlebih dahulu.',
  'Billed lines': 'Baris tagihan',
  'Billed defaults to what was received at the PO price (a clean match). Adjust the quantity or price to what the supplier actually charged — variances are flagged.':
    'Tagihan diisi otomatis sesuai yang diterima pada harga PO (cocok sempurna). Sesuaikan kuantitas atau harga dengan yang benar-benar dikenakan pemasok — selisih akan ditandai.',
  'Charges & totals': 'Biaya & total',
  'Tax + freight + other': 'Pajak + ongkos kirim + lainnya',
  '{count} line with variance': '{count} baris dengan selisih',
  '{count} lines with variance': '{count} baris dengan selisih',
  'Capture invoice': 'Catat faktur',

  // --- Reports --------------------------------------------------------------------
  'Failed to load reports.': 'Gagal memuat laporan.',
  "Couldn't load reports": 'Tidak dapat memuat laporan',
  'Reporting period': 'Periode pelaporan',
  'Last 3 months': '3 bulan terakhir',
  'Last 6 months': '6 bulan terakhir',
  'Last 12 months': '12 bulan terakhir',
  'Year to date': 'Tahun berjalan',
  'Spend analytics, procurement KPIs and savings': 'Analitik pengeluaran, KPI pengadaan, dan penghematan',
  'all properties': 'semua properti',
  '{count} order(s) in other currencies are excluded — figures are shown in {currency}.':
    '{count} pesanan dalam mata uang lain dikecualikan — angka ditampilkan dalam {currency}.',
  'Committed spend': 'Pengeluaran terkomitmen',
  '{count} orders': '{count} pesanan',
  'Avg order value': 'Rata-rata nilai pesanan',
  'Largest {amount}': 'Terbesar {amount}',
  'Open commitments': 'Komitmen terbuka',
  '{count} open orders': '{count} pesanan terbuka',
  'Est. price savings': 'Estimasi penghematan harga',
  'vs historical peak': 'vs puncak historis',
  'Spend trend': 'Tren pengeluaran',
  'Committed purchase-order value by month.': 'Nilai pesanan pembelian terkomitmen per bulan.',
  'Spend': 'Pengeluaran',
  'No spend in this period': 'Tidak ada pengeluaran pada periode ini',
  'Try a wider date range.': 'Coba rentang tanggal yang lebih luas.',
  'Top suppliers': 'Pemasok teratas',
  'No supplier spend': 'Tidak ada pengeluaran pemasok',
  'Spend by category': 'Pengeluaran per kategori',
  'No category data': 'Tidak ada data kategori',
  'Procurement KPIs': 'KPI pengadaan',
  'Average cycle times across the request-to-order flow, and current workload.':
    'Rata-rata waktu siklus di alur permintaan-ke-pesanan, dan beban kerja saat ini.',
  'Requisition approval': 'Persetujuan permintaan barang',
  'submit → decision · n={n}': 'ajukan → keputusan · n={n}',
  'PO approval': 'Persetujuan PO',
  'decision → sent · n={n}': 'keputusan → terkirim · n={n}',
  'PO issue': 'Penerbitan PO',
  'Requisition → PO': 'Permintaan barang → PO',
  'created → PO · n={n}': 'dibuat → PO · n={n}',
  'open POs': 'PO terbuka',
  'POs awaiting approval': 'PO menunggu persetujuan',
  'requisitions awaiting approval': 'permintaan barang menunggu persetujuan',
  'awaiting delivery': 'menunggu pengiriman',
  'Order status funnel': 'Corong status pesanan',
  'Orders': 'Pesanan',
  'Value': 'Nilai',
  'No orders in this period': 'Tidak ada pesanan pada periode ini',
  'Budget vs actual': 'Anggaran vs aktual',
  'Allocated vs consumed for budgets active in this period. Positive variance = under budget.':
    'Alokasi vs pemakaian untuk anggaran yang aktif pada periode ini. Selisih positif = di bawah anggaran.',
  'No budgets in this period': 'Tidak ada anggaran pada periode ini',
  'Set up budgets to track variance and savings.': 'Siapkan anggaran untuk melacak selisih dan penghematan.',
  'Consumed': 'Terpakai',
  'under budget': 'di bawah anggaran',
  'over budget': 'melebihi anggaran',
  'Price savings (indicative)': 'Penghematan harga (indikatif)',
  'Items whose latest unit price beat their historical peak, valued on volume bought this period. Indicative only — ignores spec/pack changes.':
    'Barang yang harga satuan terbarunya lebih baik dari puncak historisnya, dinilai berdasarkan volume yang dibeli periode ini. Hanya indikatif — mengabaikan perubahan spesifikasi/kemasan.',
  'No price improvements detected': 'Tidak ada perbaikan harga terdeteksi',
  'Needs repeat purchases at a lower price than the historical high.':
    'Membutuhkan pembelian berulang dengan harga lebih rendah dari harga tertinggi historis.',
  'Peak price': 'Harga puncak',
  'Latest price': 'Harga terbaru',
  'Qty (period)': 'Kts (periode)',
  'Est. saving': 'Estimasi penghematan',
};

export default finance;
